import { render, staticRenderFns } from "./registration-in-segment.report.vue?vue&type=template&id=629a6c59&scoped=true"
import script from "./registration-in-segment.report.vue?vue&type=script&lang=ts"
export * from "./registration-in-segment.report.vue?vue&type=script&lang=ts"
import style0 from "./registration-in-segment.report.vue?vue&type=style&index=0&id=629a6c59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a6c59",
  null
  
)

export default component.exports